import React from 'react'
import '../../../Styles/WatchPage/Comments/AddComments.css'

function AddComments() {
    return (
        <div className='video-comments__add-comments'>
            <div className='video-comments__add-comments--profile'>
                <img 
                    src='https://lh3.googleusercontent.com/-rW0mpavz1eo/AAAAAAAAAAI/AAAAAAAAAAA/AMZuuclprhZYyE8IHU8g2ALJYt0B46E3Vg/s88-c-k-c0x00ffffff-no-rj-mo/photo.jpg' 
                    className='video-comments__add-comments--profile-img' 
                />
            </div>
            <div className='video-comments__add-comments--input--container'>
                <input 
                    className='video-comments__add-comments--input'
                    placeholder='Add Comment'
                >

                </input>
            </div>
        </div>
    )
}

export default AddComments
